import { css } from 'styled-components';
import { getThemeData } from '@hzero-front-ui/core';
var UploadStyle = function UploadStyle(props) {
  var _getThemeData = getThemeData(props, 'common'),
    primary5 = _getThemeData.primary5,
    primary6 = _getThemeData.primary6;
  return css([".ant-upload.ant-upload{&.ant-upload-select-picture-card,&.ant-upload-drag:not(.ant-upload-disabled){:hover{border-color:", ";}.anticon{color:", ";}}&.ant-upload-drag.ant-upload-drag-hover:not(.ant-upload-disabled){border-color:", ";}}.ant-upload-list.ant-upload-list{.ant-upload-list-item:hover .ant-upload-list-item-info{background-color:rgba(0,0,0,0.04);}}"], primary5, primary6, primary5);
};
export default UploadStyle;